<template>
  <div>
    <headBox title="访客管理"></headBox>
    <div class="tbd-content">
      <!-- 搜索部分 -->
      <topSearchForm @search="searchAjax" @export="exportToExcel">
        <el-form :inline="true" class="rform" :model="searchParams" ref="loginform">
          <el-form-item label="日期">
            <a-range-picker v-model="searchParams.dateTime" format="yyyy-MM-DD" valueFormat="yyyy-MM-DD" separator="至">
              <i class="icon-riqixuanze" slot="suffixIcon"></i>
            </a-range-picker>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input v-model="searchParams.mobile" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item label="产品名称">
            <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item label="" v-if="level == 1">
            <div class="cell-border">
              <el-select
                class="left-select"
                v-model="selectedLevel"
                @change="
                  searchParams.mechanId = '';
                  getChildList();
                "
                placeholder="出单机构"
              >
                <el-option label="出单机构" value="2"></el-option>
                <el-option label="出单员工" value="3"></el-option>
              </el-select>
              <el-select class="right-select" v-model="searchParams.mechanId" clearable filterable>
                <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="出单员工" v-if="level == 2">
            <el-select v-model="searchParams.mechanId" clearable filterable>
              <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="订单编号">
            <el-input v-model="searchParams.orderNo" placeholder="请输入" clearable></el-input>
          </el-form-item>

          <el-form-item label="订单ID">
            <el-input v-model="searchParams.orderId" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </topSearchForm>

      <el-table border :data="tableData" class="list-table" tooltip-effect="dark" v-loading="listLoading">
        <el-table-column label="序号" width="50px;" type="index" fixed="left"></el-table-column>
        <el-table-column label="订单编号" property="orderNo" min-width="250px;" fixed="left"></el-table-column>
        <el-table-column label="订单ID" property="orderId" min-width="200px;"></el-table-column>
        <el-table-column label="手机号" min-width="150px;">
          <template slot-scope="scope">
            <div>{{ scope.row.mobile }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="微信昵称" min-width="200px;" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="wx-name">
              <img v-if="scope.row.imgUrl" :src="scope.row.imgUrl" alt="" />
              <p>{{ scope.row.nickname }}</p>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="产品名称" property="productName" min-width="300px;" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="出单机构" property="mechanName" min-width="200px;"></el-table-column>
        <el-table-column property="startTime" min-width="180px;" label="开始时间">
          <template slot-scope="scope">
            {{ scope.row.startTime }}
          </template>
        </el-table-column>
        <el-table-column min-width="150px;" label="停留时长">
          <template slot-scope="scope">
            {{ scope.row.totalDuration == '00:00:00' ? '-' : scope.row.totalDuration }}
          </template>
        </el-table-column>
        <el-table-column label="行为记录" property="behaviorRecordStr" min-width="300px;" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="退出节点" property="exitBehaviorStr" min-width="150px;"></el-table-column>

        <el-table-column label="是否成交" min-width="140px;">
          <template slot-scope="scope">
            <p :class="[{ green: scope.row.isHasPolicy == 1 }, 'red']">{{ scope.row.isHasPolicy == 1 ? '是' : '否' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" fixed="right">
          <template slot-scope="scope">
            <el-button-group class="button-group">
              <el-button type="text" size="small" @click="deteil(scope.row, 1)">产品明细</el-button>
              <div class="line"></div>
              <el-button type="text" size="small" @click="deteil(scope.row, 2)">订单访客</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        :layout="$tools.pageLayout"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//当前实例组件
import topSearchForm from '@/components/topSearchForm.vue';
import headBox from '@/components/head.vue';
import { common, pageTool } from '@/api/mixins';
import dayjs from 'dayjs';

export default {
  components: {
    headBox,
    topSearchForm
  },
  mixins: [common, pageTool],
  data: () => ({
    selectedLevel: '2',
    selectList: [],
    level: null //1 一级机构 2 二级机构 3 员工
  }),

  created() {
    this.level = this.$tools.getLocal('userinfo').level;
    this.initListAjax('/master/productVisitor/queryOrderList');
    this.getUserInfo();
  },

  methods: {
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      this.userinfo = this.$tools.getLocal('userinfo');
      // 1一级机构 2二级机构 3员工
      if (data.level == 1) {
        // 一级机构默认出单机构
        this.selectedLevel = '2';
        this.getChildList(); // 获取出单机构列表
      } else if (data.level == 2) {
        //二级机构没有出单机构，默认出单员工
        this.selectedLevel = '3';
        this.getChildList(); // 获取出单员工列表
      }
    },
    // 获取机构/员工列表
    getChildList() {
      let param = {
        level: this.selectedLevel
      };
      // 选中出单机构这个才传值
      if (this.selectedLevel == 2) {
        param.includeFirst = '1';
        delete this.searchParams.departmentId;
      }
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: param
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.selectList = res.data;
          }
        })
        .catch(e => {});
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    setListParams(params) {
      if (params.dateTime && params.dateTime[0]) {
        params.startTimeStart = dayjs(params.dateTime[0]).format('YYYY-MM-DD');
        params.startTimeEnd = dayjs(params.dateTime[1]).format('YYYY-MM-DD');
      }
      delete params.dateTime;
    },
    // 详情
    deteil(row, type) {
      this.$router.push({
        path: '/visitor/detail',
        query: {
          productId: row.productId || '',
          orderNo: row.orderNo || '',
          type
        }
      });
    },

    // 导出
    exportToExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$tools.daochu('/master/productVisitor/exportOrderList', params, 'PUT');
    }
  }
};
</script>

<style lang="scss" scoped>
.tbd-content {
  background: #ffffff;
  padding: 20px 30px 30px 30px;
  .cell-border {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 0;
  }
  .rform {
    .left-select {
      width: 110px !important;
      &/deep/.el-input__inner {
        border-right: 1px solid #dcdfe6;
        border-top: none;
        border-bottom: none;
        border-left: none;
        border-radius: 4px 0 0 4px;
      }
    }
    .right-select {
      width: calc(100% - 110px) !important;
      &::v-deep {
        .el-input__inner:focus {
          border-color: #dcdfe6;
        }
        .is-focus {
          .el-input__inner {
            border-color: #dcdfe6;
          }
        }
      }
      &/deep/.el-input__inner {
        border: none;
        border-radius: 4px 0 0 4px;
      }
    }
  }
}

// .el-pagination {
//   margin-top: 50px;
// }

.list-table {
  margin-top: 20px;
  .cell {
    text-align: center;
  }
  .is-left {
    .cell {
      text-align: left;
    }
  }
  .button-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .line {
    height: 12px;
    width: 1px;
    background: #dddddd;
  }
  .wx-name {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .red {
    width: 24px;
    height: 24px;
    background: rgb(255, 241, 240);
    border: 1px solid #feb9b5;
    border-radius: 4px;
    color: #f8585d;
    margin: 0 auto;
  }
  .green {
    background: rgb(246, 255, 236);
    border: 1px solid #aeea7f;
    color: #22bc02;
  }
}
</style>